window.o_global = window.o_global || {};
window.o_util = window.o_util || {};

/**
 * Utility collection of really fancy, hence hardcore, functions that should
 * be omitted as often as possible.
 *
 * @return {Object} Public methods of o_util.hardcore.
 */
o_util.hardcore = (function() {
    "use strict";

    /**
     * Executes script-tags embedded in element that was loaded asynchronously.
     *
     * @example
     * // div .exampleClass
     * //   script
     * //       ... javascript-code
     * //   p
     * //       some text
     * var divWithScriptTags = document.querySelector(".exampleClass");
     * o_util.hardcore.executeInlineScripts(divWithScriptTags);
     * // The javascript code inside the exampleClass was executed.
     *
     * @param {Object} element      The HTML Element, which contains inline scripts.
     */
    function executeInlineScripts(element) {
        var scripts = [],
            ret,
            script;

        ret = element.getElementsByTagName("script");

        // Collect all javascript code inside of script tags inside the element block.
        for (var i = 0; ret[i]; i++) {
            if (scripts && (!ret[i].type || ret[i].type.toLowerCase() === "text/javascript" || ret[i].type === "module")) {
                scripts.push(ret[i]);
            }
        }

        // Execute the javascript code.
        for (script in scripts) {
            if (scripts.hasOwnProperty(script)) {
                evalScript(scripts[script]);
            }
        }
    }

    /**
     * Evaluates and executes a script block.
     *
     * @param {Object} elem     Script element.
     */
    function evalScript(elem) {
        var data = (elem.text || elem.textContent || elem.innerHTML || ""),
            head = document.getElementsByTagName("head")[0] || document.documentElement,
            script = document.createElement("script");

        if (!!elem.src) {
            [].forEach.call(elem.attributes, function(attribute) {
                script.setAttribute(attribute.name, attribute.value);
            });

            elem.parentNode.replaceChild(script, elem);
        } else {
            script.type = "text/javascript";
            script.text = data;

            head.insertBefore(script, head.firstChild); // JS is executed immediately
            head.removeChild(script);

            if (elem.parentNode) {
                elem.parentNode.removeChild(elem);
            }
        }
    }

    /**
     * Return public API.
     */
    return {
        "executeInlineScripts": executeInlineScripts,
        "evalScript": evalScript
    };
}());

// Namespace fallbacks.
o_global.helper = o_global.helper || {};
o_global.helper.evalScript = o_util.hardcore.evalScript;
o_global.helper.executeInlineScripts = o_util.hardcore.executeInlineScripts;
